import { z } from "zod"
import { useForm } from "vee-validate"
import { toTypedSchema } from "@vee-validate/zod"
import type { TypedSchemaOutput } from "@/utils/utilityTypes"

const createUpdateUserFormSchema = z.object({
  firstName: z
    .string()
    .min(1, "Field is required")
    .max(150),
  lastName: z.string().min(1, "Field is required").max(150),
  email: z
    .string()
    .email()
    .min(1, "Field is required")
    .max(150),
})

export type CreateUpdateUserFormOutput = TypedSchemaOutput<
  typeof createUpdateUserFormSchema
>

export const useCreateUpdateUserForm = () =>
  useForm({
    validationSchema: toTypedSchema(
      createUpdateUserFormSchema
    ),
    initialValues: {
      firstName: "",
      lastName: "",
      email: "",
    },
  })
